export default {
  monthNames: {
    short: {
      january: 'JAN',
      february: 'FEB',
      march: 'MAR',
      april: 'APR',
      may: 'MAY',
      june: 'JUN',
      july: 'JUL',
      august: 'AUG',
      september: 'SEP',
      october: 'OCT',
      november: 'NOV',
      december: 'DEC',
    },
    long: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
  },
  pageNotFound: {
    warning: 'Page not found :(',
    backToPortal: 'Back to portal',
  },
  login: {
    email: {
      label: 'User\'s E-mail',
      placeholder: 'Type your Email',
    },
    password: {
      label: 'Password',
      placeholder: 'Type your Password',
      forgot: 'Forgot Password?',
      show: 'Show Password',
    },
    recoverPassword: {
      greetings: 'Hello',
      label:
        'Enter your email to recover your password. We\'ll send you a link to reset yout password.',
      resetPasswordLabel: 'Configure a new password',
      errorMessage: 'Email not found or blocked.',
      successMessage:
        'Success! A process to renew password was sent to your email.',
      renewMessage: 'Fill the form to renew your password.',
      renewError: 'Error while renewing your password, try again.',
      smallPasswordError: 'Your password must be at least 8 characters long',
      wrongPasswordError: 'The given passwords do not match',
      renewSuccess: 'Password updated successfully.',
      button: 'REDEFINE PASSWORD',
      backToLogin: 'Back to login',
      newPassword: 'New password',
      newPasswordConfirm: 'Confirm the new password',
    },
    keepMeLogged: {
      label: 'Keep me logged In',
    },
    signInButton: {
      label: 'Sign In',
    },
    welcome: 'Welcome!',
    signin: 'Sign in',
    error: 'Failure on login, verify your credentials and try again.',
    errorNotFound: 'Contact support',
    renew: 'You renewed and the address changed to a project',
  },
  index: {
    content: {
      introduction: 'Introduction',
      showIntroduction: 'SHOW INTRODUCTION',
      hideIntroduction: 'HIDE INTRODUCTION',
      minutes: 'Minutes',
      classes: 'Classes',
      showClasses: 'Show Classes',
      hideClasses: 'Hide Classes',
      dateOpenModule: 'This module will be available at',
      openSubmodule: 'OPEN SUBMODULE',
      closeSubmodule: 'CLOSE SUBMODULE',
      completed: 'COMPLETED',
      concluded: 'CONCLUDED',
      completedAt: 'COMPLETED AT',
      beginClass: 'BEGIN CLASS',
      emptyMessage: 'Currently there is not any content for this module!.',
      progressiveUnavailable: 'COMPLETE THE PREVIOUS LESSONS',
    },
    header: {
      startCourse: 'START COURSE',
      resumeCourse: 'RESUME COURSE',
      notes: {
        button: 'My notes',
        modal: {
          title: 'My notes',
          download: 'DOWNLOAD NOTES',
        },
      },
      faq: {
        button: 'FAQ',
        modal: {
          title: 'Frequent Asked Questions',
        },
      },
      search: {
        title: 'What are you looking for?',
        popularTags: 'POPULAR TAGS',
        resultCount: '{resultCount} results found for "{searchFilter}"',
        seeMore: 'See More',
      },
      nextClass: {
        title: 'YOUR NEXT CLASS',
      },
      emailSupport: 'suporte@ignicaodigital.com.br',
      doubts: 'Do you have questions or problems? Talk to our support:',
    },
    sidebar: {
      completedModules: 'COMPLETED MODULES',
    },
  },
  general: {
    labels: {
      loading: 'Loading...',
      uploading: 'Uploading File',
    },
    actions: {
      search: 'Search',
      communitySearch: 'Search in the community',
      clearSearch: 'Clear search',
      start: 'START',
      cancel: 'Cancel',
      orderBy: 'Order By',
      updateChanges: 'UPDATE CHANGES',
      access: 'Access',
      edit: 'Edit',
      remove: 'Remove',
      save: 'Save',
      back: 'Back',
      mute: 'Mute',
      unmute: 'Unmute {user}',
      saveChanges: 'Save Changes',
      filter: 'Filter',
    },
    messages: {
      noRecordFound: 'No records Found',
    },
    time: {
      formatFns: 'M/d/YYYY - H:mm',
      format: 'm/d/Y - H:i \\hour\\s',
      min: 'Min',
    },
  },
  logout: {
    label: 'Logout',
  },
  class: {
    details: {
      tags: 'Tags',
      nav: {
        description: 'Description',
        comments: 'Comments',
        extraContent: 'Extra',
        notes: 'Notes',
      },
      comments: {
        title: 'Comments',
        reply: 'Reply',
        post: 'Post',
        remove: 'Remove',
        pending: 'WAITING MODERATION',
        highlight: 'Highlight',
        highlighted: 'Highlighted',
        removeHighlight: 'Remove Highlight',
      },
      downloads: {
        download: 'Download',
        visualize: 'Visualize',
      },
    },
    progress: {
      completeClass: 'COMPLETE CLASS',
      moveToNext: 'AND MOVE TO NEXT',
      moveToPrev: 'BACK TO PREVIOUS CLASS',
      seeIndex: 'OPEN CLASS INDEX',
    },
    sidebar: {
      module: 'Module',
      noContent: 'There is no content right now',
    },
  },
  profile: {
    loadingImage: 'Loading Image...',
    imageAlt: 'Profile Image',
    changeImage: 'Change Image',
    fileSizeError: 'The file size exceeds the limit allowed',
    errorLoadingImage: 'Error loading image',
    menuTitle: 'PROFILE AND PASSWORD',
    name: 'Name',
    password: 'Password',
    retypePassword: 'Retype Password',
    passwords: {
      alertError:
        'Error updating your password, review the data and try again.',
      alertSuccess: 'Password updated successfully.',
      notMatching: 'Passwords does not match.',
    },
    updatedMessage: 'Profile successfully updated',
    updateError: 'Error updating your profile, try again later',
  },
  cookie: {
    disabled: 'Cookies disabled',
    enable:
      'Your browser cookies are disabled, reactivate then, and reload the page.',
  },
  banner: {
    defaultText: 'Edit your banner in settings',
    defaultButtonText: 'button action',
  },
  community: {
    notFound: 'Community not Found',
    title: 'Community',
    night_mode: 'Night mode',
    discussion: 'Discussion',
    labels: {
      like: 'Like',
      liked: 'Liked',
      likes: 'Likes',
      bestComments: 'Best Comments',
      updatedAt: 'Updated At',
    },
    users: {
      title: 'Users',
      members: 'Members',
      notMuted: 'Not muted',
      profile: {
        title: 'Profile',
        view: 'View Profile',
        header: 'Member Profile',
        statistics: 'Statistics',
        badges: 'Badges',
        notifications: 'Mail Notifications',
        createdPosts: 'Created Posts',
        createdComments: 'Created Comments',
        likes: 'Likes',
        postsLikes: 'Posts Likes',
        commentsLikes: 'Comments Likes',
      },
      mailSettings: {
        info: 'Notify me when...',
        postComment: 'Someone comments on my post',
        postLike: 'Someone likes my post',
        followedPostComment: 'Someone comments on a folllowed post',
        followedPostLike: 'Someone likes a followed post',
        commentLike: 'Someone likes any of my comments',
        reply: 'Someone replies any of my comments',
        postMention: 'Someone mentions me in a post',
        commentMention: 'Someone mentions me in a comment',
        badge: 'I receive a badge',
        postApproved: 'My post is approved',
        commentApproved: 'My comment is approved',
      },
    },
    list: {
      selectOne: 'Select the Community',
    },
    events: {
      openDate: 'Open Date',
      closeDate: 'Close Date',
    },
    posts: {
      viewPost: 'View {kind}',
      title: 'Posts',
      searchLabel: 'Search for member by name or email',
      actions: {
        create: 'Create New Post',
        start: 'Write new post',
        comment: 'What is on your mind?',
      },
      removed: 'Removed post',
      follow: 'Follow post',
      unfollow: 'Unfollow post',
      writeTitle: 'Write a title',
      createBookmark: 'Add to bookmark',
      removeBookmark: 'Remove from bookmark',
      kind: {
        post: 'Post',
        event: 'Event',
      },
      toTop: 'To Top',
      toAside: 'To Sidebar',
      pinTitle: 'Pin',
      pin: {
        top: 'Pin To Top',
        aside: 'Pin to Sidebar',
      },
      unpin: {
        top: 'Unpin From Top',
        aside: 'Unpin from Sidebar',
      },
      messages: {
        follow: {
          success: 'Post followed with success!',
          error: 'Could not follow post.',
        },
        unfollow: {
          success: 'Post unfollowed with success!',
          error: 'Could not unfollow post.',
        },
        createBookmark: {
          success: 'Post added to bookmark with success!',
          error: 'Could not add post from bookmark.',
        },
        removeBookmark: {
          success: 'Post removed from bookmark with success!',
          error: 'Could not remove post from bookmark.',
        },
        create: {
          error: 'Fill in the title, tag and content',
        },
      },
    },
    badges: {
      title: 'Badges',
      assign: 'Give badges',
      select: 'Select one or more badges',
      selected:
        'None selected badge | 1 selected badge | {count} selected badges',
      no_badges_registered: 'There are no medals registered',
    },
    comments: {
      loadAll: 'Load all comments',
      title: 'No comment | 1 comment | {count} comments',
      label: 'Comments',
      actions: {
        create: 'Comment',
        remove: 'Remove Comment',
        update: 'Update Comment',
        comment: 'Write a comment',
      },
      warnings: {
        remove: 'Are you sure you want remove this comment',
      },
      replies: {
        view: '1 reply | {count} replies',
        viewMore: 'View more replies',
      },
    },
    useTerms: {
      title: 'Use Terms',
      accept: 'Accept Use Terms',
      decline: 'I decline the terms',
      agreed: 'I agree with the use terms of the community',
      seeTerms: 'See the use terms of the community',
    },
    moderation: {
      title: 'Moderation',
      postStatus: 'Post status',
      status: {
        pending: 'Pending',
        visible: 'Visible',
        locked: 'Locked',
        muted: 'Muted',
      },
      filters: {
        apply: 'Apply',
        pending: 'Pending',
        locked: 'Locked',
        muted: 'Muted',
        posts: 'Filter posts',
        comments: 'Filter comments',
      },
    },
    tags: {
      popular: 'Most popular tags',
      add: 'Click and / or type to add tags',
      showAll: 'Show all',
      showLess: 'Show less',
      selectLabel: 'Click or press enter to add',
      deselectLabel: 'Click or press enter to remove',
      selectedLabel: 'Added',
      emptyListLabel: 'List is empty',
      all: 'All tags',
    },
    rules: {
      title: 'Rules',
      sidebarLabel: 'Community rules',
    },
    orders: {
      resultCount: 'Showing {resultCount} of {totalResult} members',
      apply: 'Apply',
      recent: 'Recent',
      popular: 'More popular',
      label: 'ORDER MEMBERS BY',
      posts: 'More posts created',
      postLikes: 'More likes received in posts',
      comments: 'More comments created',
      commentLikes: 'More likes received in comments',
      badges: 'More badges received',
    },
    notifications: {
      title: 'Notifications',
      timeFrom: '{time} ago',
      seeAll: 'See all',
      markAsRead: 'Mark as read',
      markAsUnread: 'Mark as unread',
      markAllAsRead: 'Mark all as read',
    },
    bookmark: {
      title: 'Bookmarks',
    },
    medias: {
      video: {
        urlPlaceholder: 'Youtube or Vimeo URL',
        postTitle: 'Add video to post',
        commentTitle: 'Add video to comment',
        add: 'Add to post',
      },
    },
  },
  pagination: {
    first: 'First',
    last: 'Last',
    next: 'Next',
    previous: 'Previous',
  },
  emojis: {
    search: 'Search',
    notfound: 'No Emoji Found',
    categories: {
      search: 'Search Results',
      recent: 'Frequently Used',
      people: 'Smileys & People',
      nature: 'Animals & Nature',
      foods: 'Food & Drink',
      activity: 'Activity',
      places: 'Travel & Places',
      objects: 'Objects',
      symbols: 'Symbols',
      flags: 'Flags',
      custom: 'Custom',
    },
  },
  textEditor: {
    toolbar: {
      fontSize: 'Font Size',
      fontType: 'Font Type',
      align: 'Align Text',
      headerType: 'Header Type',
      clean: 'Clean Text',
      textColor: 'Text Color',
      textBackground: 'Text Background',
      bold: 'Bold',
      italic: 'Italic',
      underlined: 'Underlined',
      strike: 'Strike',
      unorderedList: 'Unordered List',
      orderedList: 'Ordered List',
      link: 'Insert Link',
      image: 'Insert Image',
      subscript: 'Subscript',
      superscript: 'Superscript',
      blockquote: 'Blockquote',
      increaseIndent: 'Increase Indent',
      decreaseIndent: 'Decrease Indent',
    },
    fontSize: {
      small: 'small',
      medium: 'medium',
      large: 'large',
      huge: 'huge',
    },
    font: {
      sansSerif: 'Sans Serif',
      serif: 'Serif',
      monospace: 'Monospace',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/en_US.js